import { render, staticRenderFns } from "./Buttonset.vue?vue&type=template&id=4830b64a&"
import script from "./Buttonset.vue?vue&type=script&lang=ts&"
export * from "./Buttonset.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports